import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Environment } from 'src/app/environment/environment';
import { AuthService } from '../auth/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const environment = new Environment();

  let url: string = route.pathFromRoot
    .map((v) => v.url.map((segment) => segment.toString()).join('/'))
    .join('/');

  let isLoginPage = false;
  if (url.includes('auth')) {
    authService.proxyTokenReplace();
    return true;
  }

  if (url === '/' || url.includes('assessment')) {
    isLoginPage = true;
  }

  if (isLoginPage && authService.isAuthenticated()) {
    router.navigate(['summary']);
  } else if (isLoginPage && !authService.isAuthenticated()) {
    return true;
  }

  if (isLoginPage && authService.isAuthenticated()) {
    router.navigate(['tax']);
  } else if (isLoginPage && !authService.isAuthenticated()) {
    return true;
  }

  if (!authService.isAuthenticated()) {
    authService.LogOut();
    return false;
  }

  const token = authService.getDecodedAccessToken();
  const { roles } = route.data;

  if (roles && !roles.some((value: string) => token?.roles.includes(value))) {
    router.navigate(['/']);
    return false;
  }

  return true;
};

